import { render } from "./BaseIconSave.vue?vue&type=template&id=50c2eff2"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconSave.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50c2eff2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50c2eff2', __exports__)) {
    console.log('reload')
    api.reload('50c2eff2', __exports__)
  }
  
  module.hot.accept("./BaseIconSave.vue?vue&type=template&id=50c2eff2", () => {
    console.log('re-render')
    api.rerender('50c2eff2', render)
  })

}


export default __exports__